import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";

import lessonServices from "../../../services/lessonServices";
import LoadingSpinner from "../../LoadingSpinner";
import Modal from "../../Modal";

const LevelsChallengeModal = forwardRef(({}, ref) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [lessonID, setLessonID] = useState(null);
  const [projectDetails, setProjectDetails] = useState(null);

  // Expose openModal and closeModal to parent
  useImperativeHandle(ref, () => ({
    openModal(lesson) {
      setLessonID(lesson.lesson.id);
      setIsOpen(true);
    },
    closeModal() {
      handleCloseModal();
    },
  }));

  // Fetch lesson project details when modal opens and lessonID is set
  useEffect(() => {
    if (isOpen) {
      fetchLessonProjectDetails();
    }
  }, [isOpen]);

  const handleCloseModal = () => {
    setIsOpen(false);
    setLessonID(null);
    setProjectDetails(null);
    setIsLoading(false);
  };

  const fetchLessonProjectDetails = async () => {
    setIsLoading(true);
    try {
      const response = await lessonServices.getStudentLessonProjectDetails(lessonID);
      setProjectDetails(response);
    } catch (error) {
      console.error("Error fetching lesson project details:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={handleCloseModal}>
      {isLoading ? (
        <div className="flex items-center justify-center py-5">
          <LoadingSpinner color="green" />
        </div>
      ) : (
        <div className="space-y-4 text-center">
          {projectDetails?.image && (
            <img
              src={projectDetails.image}
              alt={projectDetails.name}
              className="mx-auto w-full max-w-md rounded-lg object-cover"
            />
          )}
          <h2 className="text-2xl font-bold text-gray-800">{projectDetails?.name}</h2>
          <p className="text-gray-600">{projectDetails?.challenge_statement}</p>
        </div>
      )}
    </Modal>
  );
});

export default LevelsChallengeModal;
